package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class AdminNotesResponse(val notes: List<AdminNote>)
